import Promise from 'es6-promise';

// Polyfill pro ECMAScript.
import 'core-js/features/array';
import 'core-js/features/number';
import 'core-js/features/object';
import 'core-js/features/string';

// Používá se odlišný polyfill pro Promise.
// Core.js polyfill má totiž problémy v kombinaci s fetch.
if (!('Promise' in window)) {
	window.Promise = Promise;
} else if (!('finally' in window.Promise.prototype)) {
	window.Promise.prototype.finally = Promise.prototype.finally;
}

// Knihovna bohužel nepodporuje ponyfill přístup.
// Před importem musí být Promise objekt připraven.
// eslint-disable-next-line no-undef
const allSettled = require('promise.allsettled/implementation');

// TODO Zrušit po implementaci v es6-promise knihovně.
// - https://github.com/stefanpenner/es6-promise/issues/354
if (!('allSettled' in window.Promise)) {
	window.Promise.allSettled = allSettled;
}
